import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import {Divider, Link, Stack } from '@mui/material';
import PageBreadcrumbs from '../../../components/PageBreadcrumbs';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import FaxIcon from '@mui/icons-material/Fax';
import QuestionForm from './QuestionForm';
import StaffDirectory from './StaffDirectory';
import { Subscription } from '../../Home1/components';

const ContactDetails = [
  {
    label: 'Main Line',
    value: '617-979-8300',
    icon: (
      <LocalPhoneIcon fontSize='small' color="primary" />
    ),
  },
  {
    label: 'Toll Free',
    value: '800-462-OCPF',
    icon: (
      <LocalPhoneIcon fontSize='small' color="primary" />
    ),
  },
  {
    label: 'Fax',
    value: '617-727-6549',
    icon: (
      <FaxIcon fontSize='small' color="primary" />
    ),
  },
  {
    label: 'Email',
    value: 'ocpf@mass.gov',
    icon: (
      <EmailIcon fontSize='small' color="primary"/>
    ),
  }
]


const ContactUs = (): JSX.Element => {

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
            variant="h5"
            align={'left'}
            data-aos={'fade-up'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            gutterBottom
            marginBottom={2}
            >
            Contact Us
        </Typography>
        <Divider/>
        <Grid container marginTop={3} spacing={4} marginLeft={5} marginBottom={3}>
          <Grid size={{xs:12, md:5}}>
              <Typography fontWeight={550} variant={'h6'} gutterBottom color={'secondary'}>
                Contact Details
              </Typography>
              <Stack spacing={1} marginTop={2}>
                {ContactDetails.map((item, i) => (
                <Stack direction={'row'} spacing={1} key={i} marginBottom={2}>
                  {item.icon} 
                  <Typography variant='body1' fontWeight={550}>{item.label}</Typography>
                  <Typography variant='body1'>{item.value}</Typography>
                </Stack>
                ))}
              </Stack>         
          </Grid>
          <Grid size={{xs:12, md:6}}>
              <Typography fontWeight={550} variant={'h6'} gutterBottom color={'secondary'}>
                Hours
              </Typography>
              <Typography variant={'body1'} gutterBottom>
                Monday - Friday: 8:30 a.m. to 4:30 p.m.
              </Typography>
              <Typography variant={'body1'} gutterBottom>
                Walk In: Tuesday, Wednesday and Thursday
              </Typography>
              <Typography variant={'body1'} gutterBottom>
                By appointment: Monday and Friday
              </Typography>              
          </Grid>
          <Grid size={{xs:12, md:5}}>
              <Typography fontWeight={550} variant={'h6'} gutterBottom color={'secondary'}>
                Mailing Address
              </Typography>
              <Typography variant={'body1'}>
                  Massachusetts Office of Campaign and Political Finance
              </Typography>
              <Typography variant={'body1'}>
                  John W. McCormack Building
              </Typography>
              <Typography variant={'body1'}>
                  One Ashburton Place, Room 411
              </Typography>
              <Typography variant={'body1'} gutterBottom>
                  Boston, MA 02108
              </Typography>          
          </Grid>
          <Grid size={{xs:12, md:6}}>
              <Typography fontWeight={550} variant={'h6'} gutterBottom color={'secondary'}>
                Request Public Records
              </Typography>
              <Typography variant={'body1'}>
                Click <Link href="/PublicSearch/ViewDocument?id=3989" target="_blank" underline="none">here</Link> for public records requests.
              </Typography>
              <Typography variant={'body1'}>
                The Records Access Officer, Jason Tait, is available at <Link target="_blank" underline="none" href="mailto:Jason.Tait@mass.gov?subject=Public Records Request">Jason.Tait@mass.gov</Link>
              </Typography>             
          </Grid>
        </Grid>
        <Divider />
        <StaffDirectory></StaffDirectory>
        <Divider />
        <QuestionForm></QuestionForm>
        <Divider />
        <Subscription></Subscription>
      </Container>
    </Main>
  );
};

export default ContactUs;